import { render, staticRenderFns } from "./AddHospitalSurgeryDoctors.vue?vue&type=template&id=8ab92f52"
import script from "./AddHospitalSurgeryDoctors.vue?vue&type=script&lang=js"
export * from "./AddHospitalSurgeryDoctors.vue?vue&type=script&lang=js"
import style0 from "./AddHospitalSurgeryDoctors.vue?vue&type=style&index=0&id=8ab92f52&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports